const NBA_TEAM_LIST = [
  {
    "abbreviation": "ATL",
    "teamName": "Atlanta Hawks",
    "location": "Atlanta"
  },
  {
    "abbreviation": "BOS",
    "teamName": "Boston Celtics",
    "location": "Boston"
  },
  {
    "abbreviation": "BKN",
    "teamName": "Brooklyn Nets",
    "location": "Brooklyn"
  },
  {
    "abbreviation": "NJN",
    "teamName": "New Jersey Nets",
    "location": "New Jersey"
  },
  {
    "abbreviation": "CHA",
    "teamName": "Charlotte Hornets",
    "location": "Charlotte"
  },
  {
    "abbreviation": "CHI",
    "teamName": "Chicago Bulls",
    "location": "Chicago"
  },
  {
    "abbreviation": "CLE",
    "teamName": "Cleveland Cavaliers",
    "location": "Cleveland"
  },
  {
    "abbreviation": "DAL",
    "teamName": "Dallas Mavericks",
    "location": "Dallas"
  },
  {
    "abbreviation": "DEN",
    "teamName": "Denver Nuggets",
    "location": "Denver"
  },
  {
    "abbreviation": "DET",
    "teamName": "Detroit Pistons",
    "location": "Detroit"
  },
  // {
  //   "abbreviation": "GSW",
  //   "teamName": "Golden State Warriors",
  //   "location": "Golden State"
  // },
  {
    "abbreviation": "HOU",
    "teamName": "Houston Rockets",
    "location": "Houston"
  },
  {
    "abbreviation": "IND",
    "teamName": "Indiana Pacers",
    "location": "Indiana"
  },
  {
    "abbreviation": "LAC",
    "teamName": "Los Angeles Clippers",
    "location": "Los Angeles"
  },
  {
    "abbreviation": "LAL",
    "teamName": "Los Angeles Lakers",
    "location": "Los Angeles"
  },
  {
    "abbreviation": "MEM",
    "teamName": "Memphis Grizzlies",
    "location": "Memphis"
  },
  {
    "abbreviation": "MIA",
    "teamName": "Miami Heat",
    "location": "Miami"
  },
  {
    "abbreviation": "MIL",
    "teamName": "Milwaukee Bucks",
    "location": "Milwaukee"
  },
  {
    "abbreviation": "MIN",
    "teamName": "Minnesota Timberwolves",
    "location": "Minnesota"
  },
  {
    "abbreviation": "NOP",
    "teamName": "New Orleans Pelicans",
    "location": "New Orleans"
  },
  {
    "abbreviation": "NYK",
    "teamName": "New York Knicks",
    "location": "New York"
  },
  {
    "abbreviation": "OKC",
    "teamName": "Oklahoma City Thunder",
    "location": "Oklahoma City"
  },
  {
    "abbreviation": "ORL",
    "teamName": "Orlando Magic",
    "location": "Orlando"
  },
  {
    "abbreviation": "PHI",
    "teamName": "Philadelphia 76ers",
    "location": "Philadelphia"
  },
  {
    "abbreviation": "PHX",
    "teamName": "Phoenix Suns",
    "location": "Phoenix"
  },
  {
    "abbreviation": "POR",
    "teamName": "Portland Trail Blazers",
    "location": "Portland"
  },
  {
    "abbreviation": "SAC",
    "teamName": "Sacramento Kings",
    "location": "Sacramento"
  },
  {
    "abbreviation": "SAS",
    "teamName": "San Antonio Spurs",
    "location": "San Antonio"
  },
  {
    "abbreviation": "TOR",
    "teamName": "Toronto Raptors",
    "location": "Toronto"
  },
  {
    "abbreviation": "UTA",
    "teamName": "Utah Jazz",
    "location": "Utah"
  },
  {
    "abbreviation": "WAS",
    "teamName": "Washington Wizards",
    "location": "Washington"
  }
];

export default NBA_TEAM_LIST;